import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const IconExclamationSolid = /*#__PURE__*/ forwardRef(({ title, titleId, size = 24, ...props }, ref)=>{
    return jsxs("svg", {
        ref: ref,
        width: size,
        height: size,
        "data-testid": "icon-exclamationsolid",
        "aria-hidden": title ? undefined : 'true',
        "aria-labelledby": titleId,
        viewBox: "0 0 20 20",
        fill: "currentColor",
        ...props,
        children: [
            title ? jsx("title", {
                id: titleId,
                children: title
            }) : null,
            jsx("path", {
                fillRule: "evenodd",
                d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.743 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98zM11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-8a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1",
                clipRule: "evenodd"
            })
        ]
    });
});
IconExclamationSolid.displayName = 'IconExclamationSolid';

export { IconExclamationSolid as default };
//# sourceMappingURL=IconExclamationSolid.js.map
